import { render, staticRenderFns } from "./OtherLabInvestigations.vue?vue&type=template&id=7ed518a2&scoped=true&"
import script from "./OtherLabInvestigations.vue?vue&type=script&lang=js&"
export * from "./OtherLabInvestigations.vue?vue&type=script&lang=js&"
import style0 from "./OtherLabInvestigations.vue?vue&type=style&index=0&id=7ed518a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed518a2",
  null
  
)

export default component.exports